// 费用类型
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("pieceFeeType") || ""
}

const getters = {
  getPieceFeeType:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("pieceFeeType",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("pieceFeeType")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}